<div class="flex pr-4 pt-4 pb-12 pl-4 pr-6" [ngClass]="mode" [ngStyle]="customStyles">
  <lib-cdw-icon [icon]="iconName" class="flex mr-4" [ngStyle]="textColor ? { color: textColor } : {}"></lib-cdw-icon>
  <div class="flex flex-col">
    <span *ngIf="infoTitle" class="info-title" [ngStyle]="titleStyles">{{ infoTitle }}</span>
    <ng-content></ng-content>
  </div>
</div>
